<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ptit"><a id="page_8"></a>PART I: THE ITALIAN CAMPAIGN</h2>
<div class="img_container">
<img alt="images" src="images/f0008-1.jpg"/><a id="page_9"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Part1.vue?c99f781c